import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UserService } from '../core/services/user.service';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root',
})
export class CasesService {
  url = `${this.env.URL_API}`;
  baseUrl = `${this.url}/casos`;
  auditoryUrl = `${this.url}/auditory_log`;
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  constructor(
    private http: HttpClient,
    private userService: UserService,
    private env: EnvService
  ) {}

  createCase(caso): Observable<any> {
    const url = this.baseUrl;
    return this.http.post(url, caso).pipe(catchError(this.handleError));
  }

  saveAuditory(type: string, more_info: any) {
    // Type can be delete, create or update
    const url = `${this.auditoryUrl}`;
    const auditory = {
      user: this.userService.currentUser,
      action: type,
      more_info,
    };
    return this.http.post(url, auditory);
  }

  getCases() {
    return this.http.get(`${this.baseUrl}`);
  }

  getCase(id): Observable<any> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.get(url, { headers: this.headers }).pipe(
      map((res: Response) => {
        return res || {};
      }),
      catchError(this.handleError)
    );
  }

  updateCase(id, caso): Observable<any> {
    // this.saveAuditory('EditCase', { caso });
    const url = `${this.baseUrl}/${id}`;
    return this.http
      .put(url, caso, { headers: this.headers })
      .pipe(catchError(this.handleError));
  }

  deleteCase(id, id_usuarios_creador, caseInfo): Observable<any> {
    // this.saveAuditory('DeleteCase', caseInfo).subscribe((res) => {
    //   console.log(res);
    // });
    const url = `${this.baseUrl}/${id}`;
    const httpOptions = {
      headers: this.headers,
      body: { id_usuarios_creador },
    };
    return this.http
      .delete(url, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Error
  handleError(error: HttpErrorResponse) {
    let msg = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      msg = error.error.message;
    } else {
      // server-side error
      msg = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(msg);
  }
}
